import styled from 'styled-components';

import YesNoDef from 'components/YesNoQuestion';
import WarningDef from 'components/Warning';

export const YesNoQuestion = styled(YesNoDef)`
  padding-top: 0;
  margin-bottom: 20px;
`;

export const Warning = styled(WarningDef)`
  margin-top: 5px;
`;
